import { axios } from './axios';

export const authApi = {
  checkSessionHealth() {
    return axios.get('/sessions/health');
  }
};
